module.exports = __webpack_public_path__ + "img/smart-plug-md.5b8752fc.svg";